
  <cml-panel-buttons [buttons]="buttons"></cml-panel-buttons>

<div class="form-container">
  <form class="form">
    <div>
      Role uživatele
      <span style="font-weight: bold">
        <span *ngIf="user?.name">{{user?.name}} {{user?.surname}}</span>
        <span *ngIf="user?.name === null">{{user?.userName}}</span>
      </span>
    </div>

    <div>
      <div *ngFor="let role of roles">
        <span>{{role.name}}</span>
        <button mat-button style="margin-left: 5px; padding: 0; min-width: 36px;" (click)="removeRole(role)">
          <i class="cml-fw cml-lg cml-trash-o"></i>
        </button>
      </div>
    </div>


    <mat-form-field *ngIf="initialized">
      <mat-label>Role</mat-label>
      <input type="text"
             aria-label="Role"
             matInput
             [formControl]="myControl"
             [matAutocomplete]="auto"
             #input>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelect($event.option.value)">
        <mat-option *ngFor="let option of filteredRoles$ | async" [value]="option.name">
          {{option.name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </form>
</div>

<cml-extended-detail></cml-extended-detail>
